export default __webpack_public_path__ + "static/ts-full-logo-ff48e056fdbb872bfff3d53a247cbc69.svg";